import { render } from "./OfferCard.vue?vue&type=template&id=4f065092&scoped=true&ts=true"
import script from "./OfferCard.vue?vue&type=script&lang=ts"
export * from "./OfferCard.vue?vue&type=script&lang=ts"

import "./OfferCard.vue?vue&type=style&index=0&id=4f065092&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f065092"]])

export default __exports__